/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial_expiry_date: NonNullable<unknown> }} Subscribed_Card_Trial_End_DateInputs */

const en_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trial End Date: ${i?.trial_expiry_date}`)
};

const ar_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تاريخ انتهاء الفترة التجريبية: ${i?.trial_expiry_date}`)
};

const de_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enddatum der Studie: ${i?.trial_expiry_date}`)
};

const es_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fecha de fin de prueba: ${i?.trial_expiry_date}`)
};

const fr_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Date de fin de l'essai: ${i?.trial_expiry_date}`)
};

const it_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Data di fine della prova: ${i?.trial_expiry_date}`)
};

const ja_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トライアル終了日：${i?.trial_expiry_date}`)
};

const ko_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`체험판 종료일: ${i?.trial_expiry_date}`)
};

const pt_br_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fim do teste: ${i?.trial_expiry_date}`)
};

const ru_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дата окончания пробной версии: ${i?.trial_expiry_date}`)
};

const th_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`วันสิ้นสุดการทดลองใช้: ${i?.trial_expiry_date}`)
};

const tr_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deneme Bitiş Tarihi: ${i?.trial_expiry_date}`)
};

const zh_cn_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`试用到期日：${i?.trial_expiry_date}`)
};

const zh_tw_subscribed_card_trial_end_date = /** @type {(inputs: Subscribed_Card_Trial_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`試用到期日：${i?.trial_expiry_date}`)
};

/**
* | output |
* | --- |
* | "Trial End Date: {trial_expiry_date}" |
*
* @param {Subscribed_Card_Trial_End_DateInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_trial_end_date = /** @type {((inputs: Subscribed_Card_Trial_End_DateInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_Trial_End_DateInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_trial_end_date(inputs)
	if (locale === "ar") return ar_subscribed_card_trial_end_date(inputs)
	if (locale === "de") return de_subscribed_card_trial_end_date(inputs)
	if (locale === "es") return es_subscribed_card_trial_end_date(inputs)
	if (locale === "fr") return fr_subscribed_card_trial_end_date(inputs)
	if (locale === "it") return it_subscribed_card_trial_end_date(inputs)
	if (locale === "ja") return ja_subscribed_card_trial_end_date(inputs)
	if (locale === "ko") return ko_subscribed_card_trial_end_date(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_trial_end_date(inputs)
	if (locale === "ru") return ru_subscribed_card_trial_end_date(inputs)
	if (locale === "th") return th_subscribed_card_trial_end_date(inputs)
	if (locale === "tr") return tr_subscribed_card_trial_end_date(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_trial_end_date(inputs)
	return zh_tw_subscribed_card_trial_end_date(inputs)
});